

import ConnectLine from './ConnectLine';
import SourceItem from './SourceItem'
import TargetItem from './TargetItem';

class ConnectContainerModel {


    constructor() {

        this.TEXT_TYPE = 0
        this.IMG_TYPE = 1
        this.TEXT_IMG_TYPE = 2

        this.sourceType = this.TEXT_TYPE;
        this.sourceTypeName = "Text";
        this.sourceItemList = []

        this.targetType = this.TEXT_TYPE;
        this.TargetTypeName = "Text"
        this.targetItemList = []

        // this.showImg = true
        this.selectedSourceStyle = []
        this.selectedTargetStyle = []

        this.connectLines = []

        this.currentSource = new SourceItem()
        this.currentTarget = new TargetItem()
        this.currentSourceHtml = ""
        this.currentTargetHtml = ""

    }

    // addSourceItem = (sourceItem) => {
    //     sourceItem.sourceIndex = this.sourceItemList.length
    //     sourceItem.sourceTxt = sourceItem.sourceIndex + 1
    //     this.sourceItemList.push(sourceItem)
    // }

    // removeSourceItem = (sourceIndex) => {

    //     this.sourceItemList.splice(sourceIndex, 1)

    //     for (let i = 0; i < this.sourceItemList.length; i++) {
    //         this.sourceItemList[i].sourceIndex = i
    //     }
    // }

    // addTargetItem = (targetItem) => {
    //     targetItem.targetIndex = this.targetItemList.length
    //     targetItem.targetTxt = targetItem.targetIndex + 1
    //     this.targetItemList.push(targetItem)
    // }
    // removeTargetItem = (targetIndex) => {

    //     this.targetItemList.splice(targetIndex, 1)

    //     for (let i = 0; i < this.targetItemList.length; i++) {
    //         this.targetItemList[i].targetIndex = i
    //     }
    // }

    getAsJson = () => {
        let obj = {}
        obj.sourceType = this.sourceType
        obj.sourceItemList = []
        for (let i = 0; i < this.sourceItemList.length; i++) {
            obj.sourceItemList.push(this.sourceItemList[i].getAsJson())
        }
        obj.targetType = this.targetType
        obj.targetItemList = []
        for (let i = 0; i < this.targetItemList.length; i++) {
            obj.targetItemList.push(this.targetItemList[i].getAsJson())
        }
        obj.connectLines = []
        for (let i = 0; i < this.connectLines.length; i++) {
            obj.connectLines.push(this.connectLines[i].getAsJson())
        }

        obj.selectedSourceStyle = this.selectedSourceStyle
        obj.selectedTargetStyle = this.selectedTargetStyle

        return obj
    }


    initFromJson = (obj) => {
        for (let i = 0; i < obj.sourceItemList.length; i++) {
            let sourceItem = new SourceItem()
            sourceItem.initFromJson(obj.sourceItemList[i])
            this.sourceItemList.push(sourceItem)
        }
        for (let i = 0; i < obj.targetItemList.length; i++) {
            let targetItem = new TargetItem()
            targetItem.initFromJson(obj.targetItemList[i])
            this.targetItemList.push(targetItem)
        }
        if (obj.connectLines) {
            for (let i = 0; i < obj.connectLines.length; i++) {
                let connectLine = new ConnectLine()
                connectLine.initFromJson(obj.connectLines[i])
                this.connectLines.push(connectLine)
            }
        }
        this.sourceType = obj.sourceType
        this.targetType = obj.targetType

        this.styleIndex = obj.styleIndex

        this.selectedSourceStyle = obj.selectedSourceStyle
        this.selectedTargetStyle = obj.selectedTargetStyle

    }
    initFromJsonTest4You = (obj) => {

        let question = obj.question
        let answerMapping = obj.answerMapping

        let questionObj = JSON.parse(question);
        let AnswerObj = JSON.parse(answerMapping);

        let list = questionObj.list
        let columnA = list.columnA
        let columnB = list.columnB

        this.sourceItemList = []
        this.targetItemList = []



        for (var key of Object.keys(columnA)) {
            this.sourceType = this.isImageURL(columnA[key]) ? this.IMG_TYPE : this.TEXT_TYPE

            let sourceItem = new SourceItem()
            sourceItem.sourceIndex = parseInt(key) - 1
            if (this.sourceType == this.IMG_TYPE)
                sourceItem.sourceImg = columnB[key].replace('###', '')
            else
                sourceItem.sourceTxt = columnA[key].replace('###', '')

            this.sourceItemList.push(sourceItem)

        }

        for (var key of Object.keys(columnB)) {
            this.targetType = this.isImageURL(columnB[key]) ? this.IMG_TYPE : this.TEXT_TYPE

            let targetItem = new TargetItem()
            targetItem.targetIndex = parseInt(key) - 1
            if (this.targetType == this.IMG_TYPE)
                targetItem.targetImg = columnB[key].replace('###', '')
            else
                targetItem.targetTxt = columnB[key].replace('###', '')

            this.targetItemList.push(targetItem)
        }

        for (var key of Object.keys(AnswerObj)) {
            let answers = AnswerObj[key]
            let source = answers[0]
            let target = answers[1]

            let sourceItem = new SourceItem();
            for (var answerKey of Object.keys(source)) {
                if (answerKey - 1 < this.sourceItemList.length) {
                    sourceItem = this.sourceItemList[parseInt(answerKey) - 1]
                }

            }

            let targetItem = new TargetItem()
            for (var answerKey of Object.keys(target)) {
                if (answerKey - 1 < this.targetItemList.length) {
                    targetItem = this.targetItemList[parseInt(answerKey) - 1]
                    targetItem.sourceItemList.push(sourceItem)
                }

            }
        }
    }



    addConnectLine = (line) => {

        let connectLine = new ConnectLine()
        connectLine.sourceItem = this.currentSource;
        connectLine.targetItem = this.currentTarget;
        connectLine.line = line
        this.connectLines.push(connectLine)
    }
    isImageURL(url) {
        return (url.match(/\.(jpeg|jpg|gif|png)$/) != null);
    }

}

export default ConnectContainerModel